export default function(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-scale/src/constant.js
// module id = 224
// module chunks = 0